import { db } from './config';
import { collection, getDocs, query, where } from 'firebase/firestore';

export const getActiveStaff = async () => {
  const q = query(collection(db, 'staff'), where('active', '==', true));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const getStaffByType = async (type) => {
  const q = query(collection(db, 'staff'), where('active', '==', true), where('type', '==', type));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};
